
<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-tabs v-model="active" :color="GetColorMain()" @change="onTabChange">
      <van-tab title="默认" name="base" />
      <van-tab title="降价" name="low" />
    </van-tabs>
    <div v-for="item in list" :key="item.favoriteId">
      <van-swipe-cell>
        <div class="rect">
          <div v-if="!item.isEnable" class="needDiy">
            <span>已失效</span>
          </div>
          <van-image
            width="6em"
            height="6em"
            :src="item.commodityicon?item.commodityicon:'/img/defaultcom.jpg'"
            @click="onItem(item.commodityId)"
          />
          <div class="bodys">
            <div class="title" @click="onItem(item.commodityId)">
              {{ item.commodityname }}
            </div>
            <div class="price" @click="onItem(item.commodityId)">
              <div :style="'color: '+GetColorMain()">
                ￥<span>{{ parseInt(item.commodityprice) }}</span>.{{ ("0"+parseInt((100*item.commodityprice+0.5-100*parseInt(item.commodityprice)))).slice(-2) }}
              </div>
              <span v-if="item.priceAdd > item.commodityprice" class="low">比关注时降价￥{{ (item.priceAdd-item.commodityprice).toFixed(2) }}</span>
            </div>
            <div class="buttons">
              <van-row>
                <van-col span="12"><van-button plain round type="default" size="mini" @click="onSame(item.commodityId)">看相似</van-button></van-col>
                <van-col span="12" class="rigth"><div class="addCar" :style="'border-color: '+GetColorMain()+';color: '+GetColorMain()" @click="onItem(item.commodityId)"><i class="iconfont icongouwuche" /></div></van-col>
              </van-row>
            </div>
          </div>
        </div>
        <template slot="right">
          <van-button square type="danger" text="删除" :loading="loadingDelete" :color="GetColorMain()" class="deleteButton" @click="onDelete(item.commodityId)" />
        </template>
      </van-swipe-cell>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Tab, Tabs, Image, SwipeCell } from 'vant'
import TopBar from '@/components/TopBar'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'

export default {
  components: {
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Image.name]: Image,
    [SwipeCell.name]: SwipeCell,
    TopBar
  },
  data() {
    return {
      active: 0,
      title: '收藏夹',
      backurl: '/my/index',
      list: [],
      listBase: [],
      loadingDelete: false,
      tabName: 'base'
    }
  },

  created() {
    this.onInit()
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,

    onInit() {
      request({
        url: '/StoreHelper/getFavoriteList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.listBase = response.data
        this.list = this.listBase
      })
    },
    onTabChange(name) {
      this.tabName = name
      if (name === 'base') {
        this.list = JSON.parse(JSON.stringify(this.listBase))
      } else if (name === 'low') {
        var list = this.listBase.filter((item) =>
          item.priceAdd > item.commodityprice
        )
        this.list = JSON.parse(JSON.stringify(list))
      }
    },
    onItem(id) {
      this.$router.push('/store/item/' + id)
    },
    onSame(id) {

    },
    onDelete(id) {
      this.loadingDelete = true
      request({
        url: '/StoreHelper/deleteFavorite',
        method: 'post',
        params: { commodityId: id }
      }).then(response => {
        this.loadingDelete = false
        if (!response.success) {
          return
        }
        this.listBase = this.listBase.filter((item) => item.commodityId !== id)
        this.onTabChange(this.tabName)
      })
    }
  }
}
</script>
<style scoped>
.rect{
  padding: 1em;
  background-color: #fff;
  position: relative;
}
.rect .bodys
{
  position: absolute;
  left: 7.5em;
  right: 1em;
  top: 1em;
  bottom: 0;
}
.rect .bodys .title{
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 0.9em;
}
 .price{
  color: #f00;
}
.price span
{
  font-size: 1.4em;
}
.price .low{
  font-size: 0.5em;
  border:1px solid #f00;
  padding: 0em 0.5em 0em 0.5em;
  border-radius: 2em;
}
.buttons button{
  height: 24px;
  line-height: 24px;
}
.addCar
{
  width: 26px;
  height: 26px;
  line-height: 26px;
  border: 1px solid #f00;
  border-radius: 2em;
  text-align: center;
  float: right;
}
.deleteButton{
  height: 100%;
}
.needDiy{
  position: absolute;
  right: 0em;
  left: -1em;
  height: 8em;
  top:0.3em;
  background-color: #000;
  color: #fff;
  line-height: 8em;
  z-index: 1;
  text-align: center;
  filter:alpha(Opacity=40);
  -moz-opacity:0.4;
  opacity: 0.4;
}
.needDiy span{
  font-size: 1.7em;
}
</style>
